<script setup lang="ts">
import { ref } from 'vue';
import RichTextEditor from './rich-text-editor.vue';
import { richTextEditorProps } from './props';
import { useErrorLogger } from './use-error-logger';

const props = defineProps(richTextEditorProps);

const { takeContentSnapshot, captureError } = useErrorLogger({ editorId: props.identifier });

const richTextEditor = ref<typeof RichTextEditor>(null);
const setContent = (content: string) => richTextEditor.value?.setContent(content);

const emit = defineEmits(['contentUpdated', 'allContentUpdated']);
defineOptions({ name: 'RichTextEditor' });
defineExpose({ setContent });

const onContentUpdated = (content: string) => {
  takeContentSnapshot(content);
  emit('contentUpdated', content);
};

</script>
<template>
  <Suspense>
    <RichTextEditor
      ref="richTextEditor"
      data-testid="richTextEditor"
      v-bind="props"
      :capture-error="captureError"
      @content-updated="onContentUpdated"
      @all-content-updated="$emit('allContentUpdated', $event)"
    />
  </Suspense>
</template>
